import React, { useEffect, useState } from 'react';
import { DashboardApis } from 'hooks/apis/DashboardApis';
import StatTile from '../../../components/common/StatTile';

const UserSamplesSubmittedTile = () => {
  const [value, setValue] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const { getUserSamplesSubmitted } = DashboardApis();

  useEffect(() => {
    getUserSamplesSubmitted()
      .then((data) => {
        if (data && !data.errorMessage) {
          setValue(data);
        } else if (data?.errorMessage) {
          setError(data.errorMessage);
        }
      })
      .finally(() => setLoading(false));
  }, [getUserSamplesSubmitted]);

  return (
    <StatTile
      label="Total Samples Submitted"
      value={value !== null ? value.toFixed(0) : '-'}
      loading={loading}
      error={error}
    />
  );
};

export default UserSamplesSubmittedTile;